import { createSlice, type PayloadAction } from '@reduxjs/toolkit';

import type { Session } from '../domain/session.model';
import { initialState } from './security-sessions.state';

/**
 * Security-sessions slice. Pure state transitions only; the I/O (list / revoke)
 * lives in the saga, which dispatches these lifecycle reducers as it progresses.
 * Revoke removes the row optimistically on success (mirrors the old page's
 * filter-out) and clears the per-row spinner on either outcome.
 */
const slice = createSlice({
  name: 'securitySessions',
  initialState,
  reducers: {
    loadStarted: (state) => {
      state.loadStatus = 'loading';
    },
    loadSucceeded: (state, action: PayloadAction<Session[]>) => {
      state.sessions = action.payload;
      state.loadStatus = 'loaded';
    },
    loadFailed: (state) => {
      state.loadStatus = 'failed';
      state.sessions = [];
    },
    revokeStarted: (state, action: PayloadAction<string>) => {
      state.revokingId = action.payload;
    },
    revokeSucceeded: (state, action: PayloadAction<string>) => {
      state.sessions = state.sessions.filter((s) => s.id !== action.payload);
      state.revokingId = null;
    },
    revokeFailed: (state) => {
      state.revokingId = null;
    },
    resetSessions: () => initialState,
  },
});

export const securitySessionsActions = slice.actions;
export const securitySessionsReducer = slice.reducer;
